import * as THREE from 'three';
import FloatingCards from '../FloatingCards.js';

export default class Renderer {
  constructor() {
    this.floatingCards = FloatingCards.getInstance();
    this.sizes = this.floatingCards.sizes;
    this.scene = this.floatingCards.scene;
    this.camera = this.floatingCards.camera;

    this.setInstance();
  }

  setInstance() {
    this.instance = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
      powerPreference: 'high-performance',
      precision: 'highp',
      logarithmicDepthBuffer: true,
      stencil: false
    });

    this.instance.setSize(this.sizes.width, this.sizes.height);
    this.instance.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  }

  resize() {
    this.instance.setSize(this.sizes.width, this.sizes.height);
    this.instance.setPixelRatio(this.sizes.pixelRatio);
  }

  render(scene, camera) {
    this.instance.render(scene, camera);
  }
}
